import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import SmartEditor from '../components/SmartEditor';
import { ArrowLeft, Code2 } from 'lucide-react';
import '../components/JsonWorkspace.css';

const HtmlEditor = () => {
    const location = useLocation();
    const [input, setInput] = useState(location.state?.code || '');

    return (
        <div className="workspace">
            <div className="toolbar">
                <div className="toolbar-group">
                    <Link to="/" style={{
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        marginRight: '12px',
                        transition: 'opacity 0.2s'
                    }}
                        onMouseOver={(e) => e.currentTarget.style.opacity = '0.8'}
                        onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
                        title="Back to Home"
                    >
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '10px',
                            background: 'linear-gradient(135deg, #f53803 0%, #f5d020 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: 'var(--shadow-glow)'
                        }}>
                            <Code2 size={20} color="#fff" />
                        </div>
                    </Link>
                </div>
                <div className="toolbar-group">
                    {/* HTML specific buttons could go here later */}
                </div>
            </div>
            <div className="workspace-content">
                <div className="panel">
                    <SmartEditor value={input} onChange={setInput} language="html" />
                </div>
            </div>
        </div>
    );
};

export default HtmlEditor;
